import { DROPDOWN_MENU_CLASS_NAME } from "./constants";
import buildOptionButton from "./buildOptionButton";

const buildDropdownMenu = (
  selectElement: HTMLSelectElement,
  dropdownButton: HTMLButtonElement
) => {
  const dropdownMenu = document.createElement("div");
  dropdownMenu.className = DROPDOWN_MENU_CLASS_NAME;
  dropdownMenu.setAttribute("role", "listbox");

  const optionButtons = Array.from(selectElement.options).map((optionElement) =>
    buildOptionButton(
      optionElement,
      selectElement,
      dropdownButton,
      dropdownMenu
    )
  );

  dropdownMenu.append(...optionButtons);

  return dropdownMenu;
};

export default buildDropdownMenu;
